<template>
	<div>
		<modal
			:exibir="exibir"
			:titulo="'Escolha o tipo de assinatura'"
			:max-width="330"
			:is-confirmar-visivel="false"
			:custom-actions="true"
			@close="fecharModal"
		>
			<template #body>
				<div class="botoes-assinatura">
					<botao-adicionar
						class="float-left"
						label="ELETRÔNICA"
						v-az-auth="permissaoAssinaturaEletronica"
						@adicionar="abrirOuFecharModalAssinaturaEletronica"
					></botao-adicionar>

					<botao-adicionar
						class="float-right"
						label="DIGITAL"
						@adicionar="abrirOuFecharModalAssinaturaDigital"
						v-az-auth="permissaoAssinaturaDigital"
					></botao-adicionar>
				</div>
			</template>
			<template #actions></template>
		</modal>

		<modal-assinatura-eletronica-generico
			v-if="exibirModalAssinaturaEletronica"
			titulo="Assinar Eletronicamente"
			nome-botao-confirmar="Assinar"
			:exibir="exibirModalAssinaturaEletronica"
			@fechar-modal="abrirOuFecharModalAssinaturaEletronica"
			@assinar-eletronicamente="$emit('assinar-eletronicamente')"
		></modal-assinatura-eletronica-generico>

		<modal-assinatura-digital-generico
			v-if="exibirModalAssinaturaDigital"
			titulo="Extensão Lacuna WebPki"
			subtitulo="A extensão WebPki é necessária para continuar o processo da assinatura digital."
			mensagem="Deseja instalar agora?"
			:exibir="exibirModalAssinaturaDigital"
			nome-botao-confirmar="Assinar"
			@assinar-digitalmente="assinarDigitalmente"
			@fechar-modal="abrirOuFecharModalAssinaturaDigital"
			@fechar-modal-pai="fecharModal"
		>
		</modal-assinatura-digital-generico>
	</div>
</template>
<script>
import { mutationTypes } from '@/core/constants'
import BotaoAdicionar from '@/views/components/botoes/adicionar/BotaoAdicionar.vue'
import ModalAssinaturaEletronicaGenerico from '@/views/components/documentos/controle-documentos/assinatura/eletronica/ModalAssinaturaEletronicaGenerico.vue'
import ModalAssinaturaDigitalGenerico from '@/views/components/documentos/controle-documentos/assinatura/digital/ModalAssinaturaDigitalGenerico.vue'

export default {
	name: 'modal-selecao-tipo-assinatura-generico',
	components: {
		ModalAssinaturaEletronicaGenerico,
		ModalAssinaturaDigitalGenerico,
		BotaoAdicionar,
	},
	props: {
		exibir: {
			type: Boolean,
			required: true,
		},
		permissaoAssinaturaEletronica: {
			type: String,
			required: true,
		},
		permissaoAssinaturaDigital: {
			type: String,
			required: true,
		},
	},
	emits: ['assinar-digitalmente', 'assinar-eletronicamente'],
	data() {
		return {
			exibirModalAssinaturaEletronica: false,
			exibirModalAssinaturaDigital: false,
		}
	},
	computed: {},
	beforeDestroy() {
		this.limparFormulario()
	},
	methods: {
		abrirOuFecharModalAssinaturaEletronica() {
			this.exibirModalAssinaturaEletronica = !this.exibirModalAssinaturaEletronica
		},
		abrirOuFecharModalAssinaturaDigital() {
			this.exibirModalAssinaturaDigital = !this.exibirModalAssinaturaDigital
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
		limparFormulario() {
			this.$store.commit(mutationTypes.COMUM.MODAL_ASSINATURA_FLOWBEE.LIMPAR)
		},
		async assinarDigitalmente(certificadoThumbprint) {
			await this.$emit('assinar-digitalmente', certificadoThumbprint)
		},
	},
}
</script>
<style lang="stylus" scoped>
.botoes-assinatura
	place-content: center
	display inline-flex
	margin-top: 20px
	width: 100%
	gap 25px

>>>.v-btn
	min-width 7.8125rem !important
</style>
